import { array, number, object, string } from 'yup';
export const campaignAssignmentSchema = object({
    driverPublicIds: array().of(string().required()).min(1, 'Pick at least one driver').required(),
    campaignPublicId: string().required(),
    startDate: string().required(),
    endDate: string().optional(),
    monthlyRate: number().min(0).required(),
    currency: string().optional(),
    photoRequestCycle: string().oneOf(['weekly', 'bi_weekly', 'monthly']).required(),
    rateCycle: string().oneOf(['weekly', 'bi_weekly', 'monthly']).optional(),
    notes: string().optional(),
});
